module.exports = __webpack_public_path__ + "static/media/no-deposit.b2ffe6cd.svg";